const MAX_ROOT_FONT_PX = 140;
/** 设计稿基准宽度（px） */
const UI_WIDTH = 375;
/** 视口宽度 ≥ 此值时 html 根字号固定为 FIXED_ROOT_FONT_PX */
const FIXED_ROOT_FONT_BREAKPOINT = 540;
const FIXED_ROOT_FONT_PX = 100;
function initRem(doc = document, win = window) {
    function isIOS() {
        let i = 0;
        let iOS = false;
        const iDevice = ['iPad', 'iPhone', 'iPod'];
        for (; i < iDevice.length; i++) {
            if (navigator.platform.indexOf(iDevice[i]) >= 0) {
                iOS = true;
                break;
            }
        }
        return iOS;
    }
    const docEl = doc.documentElement;
    function retFontSize() {
        if (isIOS())
            return;
        const computedFontSize = FIXED_ROOT_FONT_PX * (docEl.clientWidth / UI_WIDTH);
        const newFontSize = window
            .getComputedStyle(document.getElementsByTagName('html')[0])
            .fontSize.replace('px', '');
        const scale = Number(newFontSize) / Number(computedFontSize);
        docEl.style.fontSize = `${computedFontSize / scale}px`;
    }
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    const clampRootFontSize = () => {
        const current = parseFloat(docEl.style.fontSize);
        if (!Number.isNaN(current) && current > MAX_ROOT_FONT_PX) {
            docEl.style.fontSize = `${MAX_ROOT_FONT_PX}px`;
        }
    };
    const recalc = function () {
        const clientWidth = docEl.clientWidth;
        if (!clientWidth) {
            return;
        }
        if (clientWidth >= FIXED_ROOT_FONT_BREAKPOINT) {
            docEl.style.fontSize = `${FIXED_ROOT_FONT_PX}px`;
            return;
        }
        docEl.style.fontSize = `${FIXED_ROOT_FONT_PX * (clientWidth / UI_WIDTH)}px`;
        retFontSize();
        clampRootFontSize();
    };
    if (!doc.addEventListener) {
        return;
    }
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
}
initRem();
